interface Iprops {
  handleSearchChange: (event: any) => void;
  handleRatingChange: (event: any) => void;
  searchQuery: string;
  selectedRating: string;
}
const ReviewFilters = ({
  handleSearchChange,
  handleRatingChange,
  selectedRating,
  searchQuery
}: Iprops) => {
  const starRatings = ['all-stars', 5, 4, 3, 2, 1];
  return (
    <div className="flex gap-3 flex-col md:flex-row items-center md:space-x-4 justify-between py-4 md:py-8">
      <div className="xxsm:w-full md:w-[55%] lg:w-[60%] 2xl:w-[70%] relative">
        <div className="absolute left-2 top-[0.6rem] md:top-4 lg:top-5 px-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17 17L21 21M3 11C3 13.1217 3.84285 15.1566 5.34315 16.6569C6.84344 18.1571 8.87827 19 11 19C13.1217 19 15.1566 18.1571 16.6569 16.6569C18.1571 15.1566 19 13.1217 19 11C19 8.87827 18.1571 6.84344 16.6569 5.34315C15.1566 3.84285 13.1217 3 11 3C8.87827 3 6.84344 3.84285 5.34315 5.34315C3.84285 6.84344 3 8.87827 3 11Z"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <input
          type="text"
          placeholder="Search Reviews"
          className="h-[42px] md:h-[55px] lg:h-[62px] text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] outline-none pl-12 pr-2 border border-[#E4E4E4] lg:border-[#6C6C6C] rounded-[5px] md:rounded-[15px] bg-white w-full placeholder:text-[14px] md:placeholder:text-[16px]  lg:placeholder:text-[18px] xl:placeholder:text-[20px] "
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>

      <div className="flex xxsm:gap-4 xsm:gap-6 sm:gap-0 md:space-x-4 xxsm:w-full md:w-[50%] lg:w-[40%] 2xl:w-[30%] ">
        <div id="dropdown" className="relative w-full">
          <select
            className="text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] w-full h-[42px] md:h-[55px] lg:h-[62px]  px-3 lg:px-2 xl:px-3 cursor-pointer border outline-[#E4E4E4] lg:outline-[#6C6C6C] outline outline-1 xxsm:border-r-[4px] lg:border-r-[16px] border-solid border-white rounded-[5px] md:rounded-[15px] bg-white"
            required
            onChange={handleRatingChange}
            value={selectedRating}
          >
            {starRatings.map(rating => (
              <option key={rating} value={rating}>
                {rating === 'all-stars'
                  ? 'All Stars'
                  : Number(rating) === 1
                  ? `${rating} Star`
                  : `${rating} Stars`}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default ReviewFilters;
